module.exports = __webpack_public_path__ + "img/occupation-cart-head-1.f51d2ac8.png";